import createAppStore from '@biw/contests-core';

import rootReducer from './root-reducer';
import { reducers } from './reducers';
import { router } from 'app/dux/router/router';


const createStore = ( state = {} ) => {
    return router.enhancer( () => createAppStore( {
        middleware: [ router.middleware ],
        reducers,
        state: state,
        rootReducer
    } ) )();
};

export default createStore;
